
import context = require('../context');
import common = require('../../common');
import utilities = require('../utilities');

declare function require(name: string): any;

//var jsUtilities = require('../../js/jsUtilities');
//var jsClasses = require('../../js/jsClasses');

interface ISettings {
    openChildrenOnClick: boolean;
}

/** Optionnel si le mode OpenChildrenOnHover est active dans le NavigationModel. */
class Navigation2 implements common.IWebComponent {
    private _rootTarget = '.mod-navigation2';
    private _itemTarget = '.mnv-item';
    private _childrenOpenedAttr = 'navigation2-children-is-open';
    private _isInit = false;
    private _$root: JQuery;
    private _openChildrenOnClick: boolean;
    private _onItemClickAction: (key: string) => void;

    init(s?: ISettings) {
        if (this._isInit)
            return;
        this._isInit = true;

        s = s || {} as ISettings;

        this._openChildrenOnClick = s.openChildrenOnClick !== false;//default is TRUE.
        this._$root = $(this._rootTarget);

        this.setupItems();

        return context.components.add(this);
    }

    setupItems() {

        if (this._openChildrenOnClick) {
            const $items = this._$root.find(this._itemTarget);

            // const closeAll = (bypassedElements?: Element[]) => {

            //     const isBypassed = (: Element) => {
            //         if (bypassedElements)
            //             for (let i = 0; i < bypassedElements.length; i++)
            //                 if (bypassedElements[i] === e)
            //                     return true;
            //         return false;
            //     };

            //     for (let i = 0; i < $items.length; i++) {
            //         const el = $items[i];
            //         if (isBypassed(el))
            //             continue;
            //         const $item = $(el);
            //         $item.attr(this._childrenOpenedAttr, "false");
            //     }
            // };

            $items.on('click', e => {
                e.stopPropagation();//<- bloquer le click sur l'element parent.

                const $item = $(e.currentTarget);
                const $parent = $item.parent().closest(this._itemTarget);
                const mustOpen = $item.attr(this._childrenOpenedAttr) !== 'true';

                const $bypassedItems = [$item[0]];
                if ($parent && $parent.length)
                    $bypassedItems.push($parent[0]);

                this.closeAll($items, $bypassedItems);

                const attrVal = mustOpen ? 'true' : 'false';

                $item.attr(this._childrenOpenedAttr, attrVal);

                if (mustOpen)
                    $parent.attr(this._childrenOpenedAttr, attrVal);
            });

            // Permet de faire fonctionner le close des menus
            document.addEventListener("mousedown", e => {
                const currentEl = e.target as Element;

                if (utilities.isOutside(currentEl, this._$root[0]))
                    this.closeAll($items);
            });
        }
    }
    closeAll($items?: JQuery, bypassedElements?: Element[]) {
        $items = $items || this._$root.find(this._itemTarget);

        const isBypassed = (e: Element) => {
            if (bypassedElements)
                for (let i = 0; i < bypassedElements.length; i++)
                    if (bypassedElements[i] === e)
                        return true;
            return false;
        };

        setTimeout(() => {
            for (let i = 0; i < $items.length; i++) {
                const el = $items[i];
                if (isBypassed(el))
                    continue;
                const $item = $(el);
                $item.attr(this._childrenOpenedAttr, "false");
            }
        }, 50);
    }

    setOnItemClickAction(action: (key: string) => void) {
        this._onItemClickAction = action || null;
        return this;
    }

    onItemClick(e: Event, key: string) {
        if (this._onItemClickAction)
            this._onItemClickAction(key);
    }
}

export = Navigation2;